/**
 * Grants de asientos (crear/editar) — sincronizar con smart_back y server_admin.
 *
 * No son módulos con ruta: controlan solo las mutations de asientos. Default-DENY
 * para roles externos (USER_SMARTCFO) y default-ALLOW para el equipo interno.
 * En el admin se editan en Permisos de Funciones (no en el árbol de Contabilidad).
 */
export const CREAR_ASIENTO_MODULE_ID = 'crear_asiento'
export const EDITAR_ASIENTO_MODULE_ID = 'editar_asiento'

export const ASIENTO_GRANT_MODULE_IDS = [
  CREAR_ASIENTO_MODULE_ID,
  EDITAR_ASIENTO_MODULE_ID,
]

export const ASIENTO_GRANT_LABELS = {
  [CREAR_ASIENTO_MODULE_ID]: 'Crear Asientos',
  [EDITAR_ASIENTO_MODULE_ID]: 'Editar Asientos',
}

/** Features del modal Permisos de Funciones (storage: modulePermissions). */
export const ASIENTO_GRANT_FEATURES = [
  {
    id: CREAR_ASIENTO_MODULE_ID,
    moduleGrant: true,
    label: 'Crear Asientos',
    description:
      'Permite crear asientos contables (mutations createEntries / devengarEntry). Por defecto denegado a usuarios externos; el equipo interno lo tiene activo.',
    items: [
      'Crear asientos nuevos desde el portal',
      'Devengar asientos',
    ],
  },
  {
    id: EDITAR_ASIENTO_MODULE_ID,
    moduleGrant: true,
    label: 'Editar Asientos',
    description:
      'Permite modificar o eliminar asientos existentes (mutations modifyEntry / deleteEntry). Por defecto denegado a usuarios externos; el equipo interno lo tiene activo.',
    items: [
      'Editar asientos existentes',
      'Eliminar asientos',
    ],
  },
]

export function isAsientoGrantModule(moduleId) {
  return ASIENTO_GRANT_MODULE_IDS.includes(moduleId)
}
